import React, { useState, useEffect, useRef } from "react";
import * as _ from "lodash";
import "../../Invs/AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead, WaterMarkName } from "../../Invs/ShareFunctionsPrint";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import HeaderJard from "./A4/HeaderJard";
import BodyJard, { Totals, TotalsUn } from "./A4/GardTable";
import FooterA from "./A4/FooterA";

function HeadersNew(props) {
    const { found,typePrint } = props;
    return (
        <div style={stylePaddingHead}>
            <HeaderJard found={found} typePrint={typePrint} />
        </div>
    );
}
function BodyPrint(props) {
    const { chunk, isLast,typePrint } = props;
    return (
        <div style={stylePadding}>
            <BodyJard
                data={chunk ?? []}
                isLast={isLast}
                typePrint={typePrint}
            />
        </div>
    );
}

function Footers(props) {
    const { found } = props;
    const clas = useInvAF();
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <FooterA found={found}
                isLast={false}
                num={2} />
        </div>
    );
}

function RevJardPrint(props) {
    const { info, data ,typePrint} = props;
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const totalsRef = useRef(null);
    const rowRefs = useRef([]);
    const [pages, setPages] = useState([]);

    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const TOTALSR = totalsRef.current?.offsetHeight || 0;
            const max_Height = PAGE_HEIGHT - (HEADER1 + FOOTER1 + 20);
            const heights = rowRefs.current.map(el => el?.offsetHeight || 0);
            let maxHightsAll = PAGE_HEIGHT - (HEADER1 + FOOTER1 + 10);;

            const max_HeightFirst = PAGE_HEIGHT - (HEADER1 + FOOTER1 + 10);
            const max_HeightOnther = PAGE_HEIGHT - (FOOTER1 + 10);
            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            data.forEach((item, i) => {
                const rowHieght = heights[i];
                maxHightsAll = pageInvoice.length === 0 ? max_HeightFirst : max_HeightOnther;
                if (currentHeight + rowHieght > maxHightsAll) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + TOTALSR > maxHightsAll) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [data]);
    return (
        <>
            <div className="measurecon" >
                <div ref={headerRef}>
                    <HeadersNew found={info} typePrint={typePrint}/>
                </div>
                {data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowRefs.current[i] = el)}
                        className="measurerow"
                    >
                        {item.Name_Item}
                    </div>
                ))}
                <div ref={totalsRef}>
                   {typePrint==1? <Totals />:<TotalsUn />}
                </div>
                <div ref={footerRef}>
                    <Footers found={info} />
                </div>
            </div>
            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <WaterMarkName found={info} />
                        <div className="contentview">
                            {i == 0 && (
                                <HeadersNew found={info} typePrint={typePrint}/>
                            )}
                            <BodyPrint chunk={page ?? []} isLast={i == pages.length - 1}  typePrint={typePrint}/>
                        </div>
                        <Footers found={info} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default RevJardPrint;
